module.exports = __webpack_public_path__ + "img/u20.a038f079.png";